<template>
  <v-row>
    <v-col cols="12" class="pt-0 pb-4">
      <Title title="Текущая специальность" font-size="15" text-start/>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.specialityFrom"
        :items="dictionaries.speciality"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Специальность</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.courseNumberFrom"
        :items="dictionaries.courseNumber"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Номер курса</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.group"
        :items="dictionaries.groupNumber"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Группа</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.paidFormFrom"
        :items="dictionaries.paidForm"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Тип обучения</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" class="py-0">
      <v-autocomplete
        v-model="application.educationFormFrom"
        :items="dictionaries.educationForm"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Форма обучения</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" class="pt-0 pb-4">
      <Title title="Желаемая специальность" font-size="15" text-start/>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.specialityTo"
        :items="dictionaries.speciality"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Специальность</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.courseNumberTo"
        :items="dictionaries.courseNumber"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Номер курса</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.paidFormTo"
        :items="dictionaries.paidForm"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Тип обучения</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.educationFormTo"
        :items="dictionaries.educationForm"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Форма обучения</span>
        </template>
      </v-autocomplete>
    </v-col>

  </v-row>
</template>

<script>

import {Application} from '@/models'
import Title from "@/components/ui/Title";
import DatePicker from "@/components/ui/DatePicker"
import {mapGetters} from "vuex"

export default {
  name: 'Application',

  components: {
    Title,
    DatePicker
  },

  props: {
    dialog: Boolean,
    item: Application
  },

  data() {
    return {
      application: new Application(),
    }
  },

  validations() {
    return {
      application: {
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['dictionaries']),
  },

  methods: {
    setApplication() {
      this.$emit('set-data', this.application)
    },

    async setExpirationDate(value) {
      this.application.expirationDate = value
      await this.saveApplication()
    },
  },

  watch: {
    'item.id': {
      immediate: true,
      handler() {
        this.application = Application.build(this.item)
      }
    }
  }
}
</script>
<style scoped>
</style>
